<app-modal>
    <p class="text fz_l fw_500 title">{{title}}</p>
    <p class="text fz_m">{{text}}</p>
    <div class="btns_container row fw_500 fz_s">
        <button (click)="closeModal()" class="btn btn_cancel">Отмена</button>
        <button (click)="delete()" class="btn dark_btn row">{{buttonText}} </button>
    </div>
</app-modal>